<template>
    <div>
        LOG
    </div>
</template>

<script>
export default {
    props: ["productId"],
    data: () => ({

    })
}
</script>